module.exports = __webpack_public_path__ + "static/aws-0a0f6bd51b345c0338fb463a6370db46.png";